import { forwardRef, useCallback, type ChangeEventHandler, type MouseEventHandler } from 'react';
import styled from 'styled-components';
import Icon, { ICON_SEARCH_LINE, ICON_CIRCLE_CLOSE } from '~/components/icon/index';
import { DesktopSearchInput } from '../search.styles';

const DesktopSearchContainer = styled.div`
	position: relative;
	width: 100%;
	border-radius: 6px;
	overflow: hidden;
`;

type Props = {
	inSearchRoute: boolean;
	keyword: string;
	updateSearchKeyword: (keyword: string) => void;
	clear: () => void;
	navigateToSearch: MouseEventHandler<HTMLInputElement>;
	placeholder: string;
	showClearButton: boolean;
};
const SearchDesktop = forwardRef<HTMLInputElement, Props>(
	({ inSearchRoute, keyword, updateSearchKeyword, clear, navigateToSearch, placeholder, showClearButton }, ref) => {
		const onChange: ChangeEventHandler<HTMLInputElement> = useCallback(
			event => {
				updateSearchKeyword(event.target.value);
			},
			[updateSearchKeyword]
		);
		return (
			<DesktopSearchContainer>
				<button
					className={`search-icon search-icon--desktop${inSearchRoute ? ' search-icon-desktop--open' : ''}`}
					data-at="search-icon-casino-nav-bar"
				>
					<Icon type={ICON_SEARCH_LINE} height="20" width="20" />
				</button>
				<DesktopSearchInput
					ref={ref}
					onChange={onChange}
					onClick={navigateToSearch}
					value={inSearchRoute ? keyword : ''}
					placeholder={placeholder}
					type="search"
					data-at="search-inputfield-casino-nav-bar"
				/>
				{showClearButton && (
					<button
						className="search-icon search-icon--desktop search-icon--right"
						onClick={clear}
						data-at="search-close-icon-casino-nav-bar"
					>
						<Icon type={ICON_CIRCLE_CLOSE} />
					</button>
				)}
			</DesktopSearchContainer>
		);
	}
);
SearchDesktop.displayName = 'SearchDesktop';

export default SearchDesktop;
